// flatten object by concatting values
function concatValues(obj) {
  var value = '';
  for (var prop in obj) {
    value += obj[prop];
  }
  return value;
}

var progFilters = document.querySelector('.prog-filters');
if (progFilters) {
  var buttonGroups = document.querySelectorAll('.prog-filters__group');
  var hashFilter = getHashFilter();
  var elem = document.querySelector('.prog-items');

  function getHashFilter() {
    // get filter=filterName
    var matches = location.hash.match(/filter=([^&]+)/i);
    var hashFilter = matches && matches[1];
    return hashFilter && decodeURIComponent(hashFilter);
  }

  var iso = new Isotope(elem, {
    itemSelector: '.sortable-item',
    stamp: '.sticky',
    percentPosition: true,
    columnWidth: '.prog-items__sizer',
    // use filterFns
    filter: hashFilter,

    getSortData: {
      status: '[data-order]', // value of attribute
    },
    sortBy: 'status',
  });

  function onHashchange() {
    //Grab the value
    var hashFilter = getHashFilter();
    
    //trigger the filter
    iso.arrange({ filter: hashFilter });

    // set selected class on button
    if (hashFilter) {
      var hasFilters = hashFilter.split('.');
      var filterLength = hasFilters.length;

      for (var i = 0; i < filterLength; i++) {

        console.log(hasFilters[i]);

        var matchingIntro = document.querySelector('.prog-intro__city[data-city="' + hasFilters[i] + '"]');
        if (matchingIntro) {
          document.querySelectorAll('.prog-intro__city').forEach(function (intro) {
            intro.classList.remove('visible');
          });
          matchingIntro.classList.add('visible');
        }
        //Do something
        buttonGroups.forEach(function (group) {
          group.querySelectorAll('[data-filter=".' + hasFilters[i] + '"]').forEach(function (button) {
            group.querySelectorAll('.selected').forEach(function (selectedButton) {
              selectedButton.classList.remove('selected');
            });
            button.classList.add('selected');
          });
        });
      }
    }
  }


  

  /* The filter functions */
  var filters = {};
  document.querySelectorAll('.filter').forEach(function (filter) {
    filter.addEventListener('click', function () {
      var button = this;

      // get group key
      var buttonGroup = button.closest('.prog-filters__group');
      var filterGroup = buttonGroup.getAttribute('data-filter-group');

      // set filter for group
      filters[filterGroup] = button.getAttribute('data-filter');

      // combine filters
      var filterValue = concatValues(filters);

      location.hash = 'filter=' + encodeURIComponent(filterValue);
      onHashchange();
    });
  });

  onHashchange();
  //window.addEventListener('hashchange', onHashchange);
}

var buttons = document.querySelectorAll('.prog-filters__buttons__button');
if (buttons) {
  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      var targetSelector = button.getAttribute('data-target');
      var targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        // Toggle is-visible class on the target element
        if (targetElement.classList.contains('is-visible')) {
          targetElement.classList.remove('is-visible');
        } else {
        // Remove is-visible class from all other items
        document.querySelectorAll('.is-visible').forEach(function (visibleElement) {
          visibleElement.classList.remove('is-visible');
        });
          targetElement.classList.add('is-visible');
        }
      }
    });
  });
}

var currentPath = window.location.pathname;
var basePath = currentPath.includes('kinderparade') ? 'kinderparade' : 'programma';


// Show calendar without requiring a click
const progDatepickerEl = document.querySelector('.prog-datepicker');
var datepicker = progDatepickerEl ? progDatepickerEl.flatpickr({
  minDate: '2026-06-19',
  maxDate: '2026-08-30',
  enable: [
    {
      from: '2026-06-19',
      to: '2026-06-28',
    },
    {
      from: '2026-07-03',
      to: '2026-07-19',
    },
    {
      from: '2026-07-24',
      to: '2026-08-09',
    },
    {
      from: '2026-08-14',
      to: '2026-08-30',
    },
  ],
  dateFormat: 'd-m-Y',
  static: true,
  theme: 'airbnb',
  yearSelector: false,
  postition: 'below',
  onClose: function (selectedDates, dateStr, instance) {
    // Close the calendar when a date is selected
    instance.open();
  },
  locale: {
    firstDayOfWeek: 1, // Set Monday as the first day of the week
    weekdays: {
      shorthand: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
      longhand: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
    },
    months: {
      shorthand: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
      longhand: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
    },
  },

  onChange: function (_, dateStr) {
    window.location.href = '/'+basePath+'?dag=' + dateStr;
  },
}) : null;


if (datepicker) {
  // Open the calendar programmatically
  datepicker.open();
}

